import React from 'react';

import Rect from '@lyearn/core/components/Rect';
import { MediasProps } from '@/components/LegacyMediaContainer/types';
import Loader from '@/components/Loader';
import dynamic from '@/utils/dynamic';

const ReactPdf = dynamic(
  () =>
    import(
      /* webpackChunkName: "react-pdf" */ '@lyearn/lygo-blocks/src/components/ReactPdf/ReactPdf'
    ),
);

function PdfPreview({ pdfClassName, media }: Pick<MediasProps, 'pdfClassName' | 'media'>) {
  return (
    <React.Suspense fallback={<Loader />}>
      <Rect disableHeight>
        {({ width }) => (
          <ReactPdf className={pdfClassName} overrideWidth={width} src={media.url!} />
        )}
      </Rect>
    </React.Suspense>
  );
}

export default PdfPreview;
